<template>
  <v-app id="home">
    <template v-if="signed">
      <v-navigation-drawer v-model="drawer" fixed temporary app>
        <v-list dense>
          <div class="mt-3">
            <img src="@/assets/logo_javer.png" height="80" width="auto">
            <v-subheader class="grey--text">
              <h2>GASTOS APP</h2>
            </v-subheader>
          </div>
          <v-divider></v-divider>
          <template v-for="item in items">
            <v-list-group v-if="item.children && isModActive(item.role)" v-model="item.model" :key="item.text"
              :prepend-icon="item.icon">
              <v-list-tile slot="activator">
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.text }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <template v-for="(child, i) in item.children">
                <v-list-tile :key="i"
                  v-if="isModActive(item.children[i].role) || (item.children[i].path == '/solicitudes/amex' && roles.indexOf('comprobacion_amex'))"
                  :to="item.children[i].path" @click.native="title = item.children[i].title"
                  @click="selectedItem(child.path)">
                  <v-list-tile-action v-if="child.icon">
                    <div v-if="child.img">
                      <div v-if="child.active">
                        <img :src="child.icon" height="auto" width="auto"
                          style="filter: brightness(0.5) sepia(1) saturate(10000%);">
                      </div>
                      <div v-else>
                        <img :src="child.icon" height="auto" width="auto" style="filter: brightness(0%);">
                      </div>
                    </div>
                    <div v-else>
                      <v-icon>{{ child.icon }}</v-icon>
                    </div>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ child.text }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list-group>
            <v-list-tile v-else-if="isModActive(item.role)" :key="item.text" :to="item.path"
              @click.native="title = item.title" @click="selectedItem(item.path)">
              <v-list-tile-action>
                <div v-if="item.img">
                  <div v-if="item.active">
                    <img :src="item.icon" height="auto" width="auto"
                      style="filter: brightness(0.5) sepia(1) saturate(10000%);">
                  </div>
                  <div v-else>
                    <img :src="item.icon" height="auto" width="auto" style="filter: brightness(0%);">
                  </div>
                </div>
                <div v-else>
                  <v-icon>{{ item.icon }}</v-icon>
                </div>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          <v-list-tile @click="logout()">
            <v-list-tile-action>
              <v-icon>exit_to_app</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                Cerrar sesión
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <v-subheader class="mt-3 grey--text">Frontend {{ frontVersion }} | Backend {{ backVersion }}</v-subheader>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar color="primary" dark dense fixed clipped-left app>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu v-model="menuAlerts" :close-on-content-click="false" :nudge-width="200" left offset-x>
          <v-btn v-if="alerts" slot="activator" color="orange" icon>
            <v-icon>notifications</v-icon>
          </v-btn>
          <v-btn v-else slot="activator" icon>
            <v-icon>notifications</v-icon>
          </v-btn>
          <v-card>
            <v-list v-if="alerts" two-line>
              <v-list-tile v-for="(item, i) in shortAlerts" @click="showAlerts()">
                <v-list-tile-content>
                  <v-list-tile-title v-if="item.observaciones === ''">
                    <strong style="color:#2196F3;">{{ 'APROBACIÓN' }}</strong> {{ ' - ' + item.tipo }}
                  </v-list-tile-title>
                  <v-list-tile-title v-else>
                    <strong style="color:#2196F3;">{{ 'MENSAJE' }}</strong> {{ ' - ' + item.tipo }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.fecha_registro"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-card-title v-else primary-title>
              <h3 class="grey--text">
                No se obtuvieron notificaciones
              </h3>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn flat color="blue-grey" @click="showAlerts()">Mostrar todo</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
        <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" left offset-x>
          <v-btn slot="activator" icon>
            <v-icon>person</v-icon>
          </v-btn>
          <v-card>
            <v-card-title primary-title>
              <div>
                <div class="headline">{{ name }}</div>
                <div v-if="roles && roles.length">
                  <div v-for="(rol, index) in roles" :key="index" class="subtitle-2">
                    {{ rol }}
                  </div>
                </div>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn flat color="primary" @click="logout()">Cerrar sesión</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-toolbar>
      <v-content>
        <v-container fluid fill-height>
          <v-layout justify-center align-center>
            <v-flex>
              <router-view @update-title="title = $event"></router-view>
              <v-snackbar v-model="error" color="error" :timeout="2500" bottom>
                {{ message }}
              </v-snackbar>
              <v-dialog v-model="loading" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                  <v-card-text>
                    Validando información
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </template>
    <template v-else>
      <v-layout row justify-center>
        <template v-if="!error">
          <v-dialog v-model="dialogSign" persistent max-width="600px">
            <v-card>
              <v-toolbar dense dark color="blue-grey">
                <v-spacer></v-spacer>
                <span class="headline">Aviso de privacidad</span>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-md>
                  <span v-html="noticePrivacy" style="text-align:justify;"></span><br>
                  <v-checkbox v-model="agree" color="success"
                    label="De conformidad con el Aviso de Privacidad así como con las transferencias de datos.">
                  </v-checkbox>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" :loading="loading" flat @click="logout()">Salir</v-btn>
                <v-btn color="blue-grey" :loading="loading" :disabled="!agree" class="white--text"
                  @click="agreeNoticePolicy()">Aceptar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template v-else>
          <v-layout row justify-center>
            <v-flex xs12 sm6 offset-sm3>
              <v-container fluid fill-height>
                <v-card color="error" class="white--text">
                  <v-card-title>
                    <div class="headline"><small>{{ msgError }}</small></div>
                  </v-card-title>
                </v-card>
              </v-container>
            </v-flex>
          </v-layout>
        </template>
      </v-layout>
    </template>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando información
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import icons from "@/config/icons";
import services from "@/config/services";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import pkg from '../../package.json';

export default {
  name: "root",
  data: () => ({
    frontVersion: null,
    backVersion: null,
    loading: false,
    error: false,
    msgError: "",
    signed: false,
    dialogSign: false,
    version: null,
    noticePrivacy: null,
    agree: false,
    drawer: null,
    title: "",
    menu: null,
    pathSelected: null,
    paths: {
      "/home": "Bienvenido",
      "/solicitudes/cajachica": "Solicitudes / Caja chica",
      "/solicitudes/reposicionfondo": "Solicitudes / Reposición de fondo",
      "/solicitudes/gastosviaje": "Solicitudes / Gastos de viaje",
      "/solicitudes/amex": "Solicitudes / Gastos AMEX",
      "/solicitudes/representacion": "Solicitudes / Representacion",
      "/solicitudes/reposicion-representacion": "Solicitudes / Reposición de Representación",
      "/solicitudes/amex/:idsolicitud_amex/comprobaciones": "Solicitudes de comprobación AMEX",
      "/reportes/contabilidad": "Reportes / Contabilidad",
      "/reportes/resumen": "Reportes / Resumen",
      "/tesoreria": "Tesorería",
      "/administracion/usuarios": "Administración / Usuarios",
      "/administracion/catalogos": "Administración / Catálogos",
      "/administracion/solicitudes": "Administración / Solicitudes",
      "/administracion/flujosaprobacion":
        "Administración / Flujos de aprobación",
      "/administracion/procesospendientes":
        "Administración / Procesos pendientes",
      "/notificaciones": "Notificaciones"
    },
    items: [
      {
        icon: "home",
        text: "Home",
        title: "Bienvenido",
        path: "/home",
        role: "*"
      },
      {
        icon: "insert_drive_file",
        text: "Solicitudes",
        role: "*",
        children: [
          {
            icon: icons["cajaChica"],
            text: "Caja chica",
            title: "Solicitudes / Caja chica",
            path: "/solicitudes/cajachica",
            role: "caja_chica",
            img: true,
            active: false
          },
          {
            icon: icons["reposicion"],
            text: "Reposición de fondo",
            title: "Solicitudes / Reposición de fondo",
            path: "/solicitudes/reposicionfondo",
            role: "caja_chica",
            img: true,
            active: false
          },
          {
            icon: icons["gastosViaje"],
            text: "Gastos de viaje",
            title: "Solicitudes / Gastos de viaje",
            path: "/solicitudes/gastosviaje",
            role: "gastos_viaje",
            img: true,
            active: false
          },
          {
            icon: 'credit_card',
            text: "Gastos AMEX",
            title: "Solicitudes / Gastos AMEX",
            path: "/solicitudes/amex",
            role: "solicitud_amex",
            img: false,
            active: false
          },
          {
            icon: 'money',
            text: "Gastos Representacion",
            title: "Solicitudes / Gastos Representacion",
            path: "/solicitudes/representacion",
            role: "gastos_representacion",
            img: false,
            active: false
          },
          {
            icon: 'credit_score',
            text: "Reposición de Representación",
            title: "Solicitudes / Reposición de Representación",
            path: "/solicitudes/reposicion-representacion",
            role: "gastos_representacion",
            img: false,
            active: false
          }
        ]
      },
      {
        icon: "pie_chart",
        text: "Reportes",
        role: "contabilidad",
        children: [
          {
            icon: "assignment",
            text: "Contabilidad",
            title: "Reportes / Contabilidad",
            path: "/reportes/contabilidad",
            role: "contabilidad"
          },
          {
            icon: "list",
            text: "Resumen",
            title: "Reportes / Resumen",
            path: "/reportes/resumen",
            role: "contabilidad"
          }
        ]
      },
      {
        icon: "monetization_on",
        text: "Tesorería",
        title: "Tesorería",
        path: "/tesoreria",
        role: "tesoreria"
      },
      {
        icon: "group",
        text: "Usuarios",
        title: "Administración / Usuarios",
        path: "/administracion/usuarios",
        role: "tesoreria"
      },
      {
        icon: "lock",
        text: "Administración",
        role: "administrador",
        children: [
          {
            icon: "group",
            text: "Usuarios",
            title: "Administración / Usuarios",
            path: "/administracion/usuarios",
            role: "administrador"
          },
          {
            icon: "assignment",
            text: "Catálogos",
            title: "Administración / Catálogos",
            path: "/administracion/catalogos",
            role: "administrador"
          },
          {
            icon: "description",
            text: "Solicitudes",
            title: "Administración / Solicitudes",
            path: "/administracion/solicitudes",
            role: "administrador"
          },
          {
            icon: "device_hub",
            text: "Flujos de aprobación",
            title: "Administración / Flujos de aprobación",
            path: "/administracion/flujosaprobacion",
            role: "administrador"
          },
          {
            icon: "priority_high",
            text: "Procesos pendientes",
            title: "Administración / Procesos pendientes",
            path: "/administracion/procesospendientes",
            role: "administrador"
          }
        ]
      },
      {
        icon: icons["notificaciones"],
        text: "Notificaciones",
        title: "Notificaciones",
        path: "/notificaciones",
        role: "*",
        img: true,
        active: false
      }
    ],
    loading: false,
    error: false,
    message: "",
    menuAlerts: false,
    name: "",
    roles: [],
    shortAlerts: [],
    timer: null
  }),
  watch: {
    $route(to, from) {
      this.title = this.paths[to.path];
      this.selectedItem(to.path);
    }
  },
  mounted() {
    this.getNoticePrivacy();
    this.frontVersion = pkg.version
    this.getBackVersion()
  },
  computed: {
    ...mapGetters("general", ["user", "alerts"])
  },
  methods: {
    ...mapActions("general", ["newUser", "newAlerts", "clearData"]),
    ws(method, name, data) {
      if (method === "get") {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          let params = "";
          for (let k in data) {
            params += k + "=" + data[k] + "&";
          }
          params = params !== "" ? "?" + params : "";
          return axios
            .get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      } else {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          return axios
            .post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      }
    },
    async getBackVersion() {
      const { data } = await axios.get(services.routes.backVersion);
      this.backVersion = data.version
    },
    isModActive(role) {
      if (role !== "*") {
        if (
          this.roles.indexOf(role) == -1 &&
          this.roles.indexOf("administrador") == -1
        ) {
          return false;
        }
      }
      return true;
    },
    selectedItem(path) {
      for (var item in this.items) {
        if (this.items[item].hasOwnProperty("children")) {
          for (var child in this.items[item].children) {
            let element = this.items[item].children[child];
            if (element.path == path) {
              if (element.hasOwnProperty("active")) {
                element.active = true;
              }
            } else {
              if (element.hasOwnProperty("active")) {
                element.active = false;
              }
            }
          }
        } else {
          let element = this.items[item];
          if (element.path == path) {
            if (element.hasOwnProperty("active")) {
              element.active = true;
            }
          } else {
            if (element.hasOwnProperty("active")) {
              element.active = false;
            }
          }
        }
      }
    },
    agreeNoticePolicy() {
      this.loading = true;
      let data = {
        version: this.version,
        html: this.noticePrivacy
      };
      this.ws("post", "nuevaFirmaAvisoPrivacidad", data)
        .then(res => {
          if (res.ok) {
            this.$router.go();
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getNoticePrivacy() {
      this.ws("get", "firmaAvisoPrivacidad").then(res => {
        if (res.ok) {
          if (res.data.fecha_registro != null && res.data.version != null) {
            this.signed = true;
            if (this.name !== "") {
              this.name = this.user.name;
              this.roles = this.user.roles;
            } else {
              this.ws("get", "check").then(res => {
                if (res.ok) {
                  this.newUser({
                    usr_nm: res.data.usr_nm,
                    roles: res.data.roles
                  });
                  this.name = this.user.name;
                  this.roles = this.user.roles;
                } else {
                  this.$router.push("/login");
                }
              });
            }
            this.title = this.paths[this.$route.path];
            this.getAlerts();
            this.timer = setInterval(this.getAlerts, 5000);
            this.selectedItem(this.$route.path);
          } else {
            this.version = res.data.version;
            this.noticePrivacy = res.data.html;
            this.dialogSign = true;
          }
        } else {
          this.error = true;
          this.msgError = res.message;
        }
      });
    },
    showAlerts() {
      this.menuAlerts = false;
      this.$router.push("/notificaciones");
    },
    getAlerts() {
      this.ws("get", "ultimasNotificaciones").then(res => {
        if (res.ok) {
          this.shortAlerts = res.data.notificaciones;
          this.newAlerts(true);
        } else {
          this.shortAlerts = [];
          this.newAlerts(false);
        }
      });
    },
    logout() {
      if (this.$session.exists()) {
        let jwt = this.$session.get("jwt");
        let headers = {
          Authorization: "Bearer " + jwt
        };
        this.axios
          .post(services.routes.logout, null, { headers })
          .then(response => {
            let res = response.data;
            if (res.correcto) {
              clearInterval(this.timer);
              this.$session.destroy();
              this.clearData();
              this.$router.push("/login");
            } else {
              this.error = true;
              this.message = res.mensaje;
            }
          })
          .catch(error => {
            console.log(error);
            this.error = true;
            this.message =
              "El servicio no se encuentra disponible en estos momentos";
          });
      } else {
        this.$router.push("/login");
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
